export { default as App } from './App';
export { default as DefaultPage } from './DefaultPage';



// WEBPACK FOOTER //
// ./src/features/home/index.js